<div class="card-body">
    <div class="float-end">
        <div class="text-end">
            <span class="badge mx-1" [ngClass]="EnumNames.getSubscriptionTypeClass(subscription.type)">
                {{ EnumNames.getSubscriptionType(subscription.type) }}
            </span>
            <span [ngClass]="subscription.statusBadgeColour" class="badge mx-1">
                {{ subscription.status }}
            </span>
        </div>

        <div *ngIf="subscription.showTimer">
            <app-countdown-timer [createdAt]="subscription.createdAt" [scale]="'small'"></app-countdown-timer>
        </div>
    </div>

    <div>
        <a [routerLink]="['/client', subscription.clientRef.id, 'subscription', subscription.$key]">
            <h3 class="card-title">{{ subscription.baysBooked }} {{ subscription.baysNamePlural }} at {{ subscription.denormParkingTitle || '' }}</h3>
        </a>
    </div>

    <div>
        <strong>{{ subscription.startDate | formatDate }} - {{ subscription.endDate | formatDate }}</strong>
        for <strong>{{ subscription.period }} {{ subscription.termNamePlural }}</strong>
    </div>

    <div class="mt-1">
        <div *ngIf="subscription.$paymentMethod">
            <span class="badge bg-secondary text-white">
                <i class="fa-brands {{ subscription.$paymentMethod.icon }}"></i>
                {{ subscription.$paymentMethod.getCardName() }}
            </span>
            &nbsp;
            <a (click)="showPaymentMethodPopup()" class="text-info text-decoration-underline"><i class="fa fa-rotate"></i> Change payment method</a>
        </div>
    </div>

    <div class="mt-1" *ngIf="subscription.$parking?.usePolicyUrl">
        <a href="{{ subscription.$parking?.usePolicyUrl }}" target="_blank" class="text-info text-decoration-underline"> <i class="fa fa-file-text"></i> Download Parking Use Policy and Terms </a>
    </div>

    <div class="mt-1" *ngIf="subscription.$parking?.leaseAgreementUrl">
        <a href="{{ subscription.$parking?.leaseAgreementUrl }}" target="_blank" class="text-info text-decoration-underline"> <i class="fa fa-file-text"></i> Download Lease Agreement </a>
    </div>
</div>
<div class="card-footer text-end">
    <div *ngIf="subscription.plan?.feeInCents" class="float-start p-2">
        <!-- Convert this into a function -->
        <strong class="text-danger">R{{ subscription.periodFee | formatCents }}</strong> {{ subscription.plan.term | parkingPlanTerm }}
    </div>
    <a [routerLink]="['/client', subscription.clientRef.id, 'subscription', subscription.$key]" class="btn btn-primary text-end" type="button">View Details </a>
</div>

<ng-container *ngIf="subscription">
    <app-client-choose-payment-method
        [openPopup]="openPopup"
        [parking]="subscription.$parking!"
        [subscriptionReference]="subscription.$key!"
        [updatingCreditCard]="true"
    ></app-client-choose-payment-method>
</ng-container>
<!--<app-client-choose-payment-method (onClosed)="onPaymentMethodClosed()" [closeOnAdded]="true"-->
<!--                                  [openPopup]="openAddPaymentMethod"-->
<!--                                  [popupMode]="'addCard'"></app-client-choose-payment-method>-->
